import React from 'react';
import styled from 'styled-components';
import CoreVideo from 'gatsby-theme-core/src/components/video';
import Content from '../../content';
import Column from '../../column';

const Video = ({
  // id,
  columnWidth,
  align,
  justify,
  card,
  order,
  title,
  youtubeVideocode,
  vimeoCode,
  background,
  className,
  offset,
}) => (!(vimeoCode || youtubeVideocode) ? null : (
  <Column
    className={className}
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card={card}
    order={order}
    offset={offset}
  >
    <Content css="width: 100%">
      {title && <h1>{title}</h1>}
      <CoreVideo
        source={vimeoCode ? 'vimeo' : 'youtube'}
        video={vimeoCode || youtubeVideocode}
        background={background}
      />
    </Content>
  </Column>
));

export default styled(Video)``;
